import { createContext, useContext, ReactNode, FC } from "react"

import { FindAllActivitiesResponseDto, useFindAllActivities } from "~/gen/api"

type ActivitiesContextType = FindAllActivitiesResponseDto[]

export const ActivitiesContext = createContext<ActivitiesContextType>([])

export const useActivitiesContext = () => {
  const context = useContext(ActivitiesContext)
  if (!context) {
    throw new Error(
      "useActivitiesContext must be used within a ActivitiesProvider"
    )
  }
  return context
}

export const ActivitiesProvider: FC<{
  children: ReactNode
}> = ({ children }) => {
  const { data: activities } = useFindAllActivities()

  return (
    <ActivitiesContext.Provider value={activities?.data ?? []}>
      {children}
    </ActivitiesContext.Provider>
  )
}
